<div class="deep-link-wrapper">
  <div class="container h-100">
    <div class="d-flex">
      <div class="wrapper">
        <div class="img">
          <img
            src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/sale-hifpt/logo_HiFPT.png"
            alt=""
            width="auto"
            height="auto"
          /><span class="bold">Hi FPT</span>
        </div>
        <div class="text">
          <p>Hi FPT - CHẠM LIỀN TAY, HỖ TRỢ NGAY</p>
          <p>
            Với tiêu chí Đơn giản hóa thủ tục, Tiết kiệm chi phí, An toàn và bảo mật
          </p>
        </div>
        <div class="button"><a (click)="openLink()">Open</a></div>
      </div>
    </div>
  </div>
</div>
